































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import EditDialogMixin from '@/common/dialogs/mixins/edit-dialog-mixin'
import Candidate from '@/evaluations/entities/candidate'
import candidateService from '../services/candidate-service'

@Component
export default class CandidateDialog extends Mixins<EditDialogMixin<Candidate>>(
  EditDialogMixin
) {
  model = new Candidate()
  private items: Candidate[] = []
  private search = ''

  @Watch('search')
  private async searchChanged(val: string, old: string) {
    if (val && val !== old) {
      this.loading = true
      await candidateService
        .findForSelect(val)
        .then((res) => (this.items = res))
      this.loading = false
    }
  }
}
